import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

const mesesOpts = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const currentYear = new Date().getFullYear();
const aniosOpts = [currentYear - 1, currentYear - 2]
  .filter(year => year >= 2026)
  .map(year => ({ label: year, value: year }));

export type Inputs = "mes" | "anio";
export type Buttons = "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts
      }
    },
    {
      name: "anio",
      label: "* Año",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear,
        data: aniosOpts
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Consultar Periodo",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      required: {
        validator: value => !value,
        message: () => "El mes es requerido"
      }
    }
  },
  rows: [["mes", "anio", "buscar"]]
};
